import { render, staticRenderFns } from "./ImagesAdmin.vue?vue&type=template&id=c27e64b4&scoped=true"
import script from "./ImagesAdmin.vue?vue&type=script&lang=js"
export * from "./ImagesAdmin.vue?vue&type=script&lang=js"
import style0 from "./ImagesAdmin.vue?vue&type=style&index=0&id=c27e64b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27e64b4",
  null
  
)

export default component.exports